// src/binding.ts
var Binding = class _Binding {
  #keys;
  #help;
  #disabled;
  constructor(options = {}) {
    this.#keys = options.keys ?? [];
    this.#help = options.help ?? { key: "", desc: "" };
    this.#disabled = options.disabled ?? false;
  }
  /** Returns the keys for this binding. */
  keys() {
    return this.#keys;
  }
  /** Returns the help text for this binding. */
  help() {
    return this.#help;
  }
  /**
   * Returns true if this binding is enabled (not disabled and has keys).
   * Disabled bindings won't be matched and won't show up in help.
   */
  enabled() {
    return !this.#disabled && this.#keys.length > 0;
  }
  /** Returns a new Binding with the given keys. */
  withKeys(...keys) {
    return new _Binding({
      keys,
      help: this.#help,
      disabled: this.#disabled
    });
  }
  /** Returns a new Binding with the given help text. */
  withHelp(key, desc) {
    return new _Binding({
      keys: this.#keys,
      help: { key, desc },
      disabled: this.#disabled
    });
  }
  /** Returns a new Binding with disabled set to the given value (default: true). */
  withDisabled(disabled = true) {
    return new _Binding({
      keys: this.#keys,
      help: this.#help,
      disabled
    });
  }
  /** Returns a new Binding with enabled set (inverse of disabled). */
  withEnabled(enabled = true) {
    return this.withDisabled(!enabled);
  }
  /**
   * Returns a new Binding with keys and help cleared.
   * This is a step beyond disabling—it nullifies the binding entirely.
   */
  unbound() {
    return new _Binding({
      keys: [],
      help: { key: "", desc: "" },
      disabled: this.#disabled
    });
  }
};
function newBinding(options) {
  return new Binding(options);
}

// src/matches.ts
function matches(key, ...bindings) {
  const keyStr = key.toString();
  for (const binding of bindings) {
    if (!binding.enabled()) {
      continue;
    }
    for (const k of binding.keys()) {
      if (keyStr === k) {
        return true;
      }
    }
  }
  return false;
}

export { Binding, matches, newBinding };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map